import React from "react";
import IconButton from "material-ui/IconButton";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import "./OptionsTableRowColumnStyle.css";

const OptionsTableRowColumn = props => {
	const styles = {
		iconStyle: {
			padding: 2
		}
	};
	return (
		<div>
			{props.handleShow ? (
				<Tooltip title={props.showTooltip} position="top">
					<IconButton
						disabled={props.activeButton}
						style={styles.iconStyle}
						onClick={props.handleShow}
						iconClassName="material-icons"
					>
						remove_red_eye
					</IconButton>
				</Tooltip>
			) : null}
			{props.codeMembers ? (
				<Tooltip title="Códigos/Miembros" position="top">
					<IconButton
						disabled={props.activeButton}
						style={styles.iconStyle}
						onClick={props.codeMembers}
						iconClassName="material-icons"
					>
						people
					</IconButton>
				</Tooltip>
			) : null}
			{props.handleEdit ? (
				<Tooltip title="Editar" position="top">
					<IconButton
						disabled={props.activeButton}
						style={styles.iconStyle}
						onClick={props.handleEdit}
						iconClassName="material-icons"
					>
						edit
					</IconButton>
				</Tooltip>
			) : null}
			{props.handleDelete ? (
				<Tooltip title="Anular" position="top">
					<IconButton
						disabled={props.activeButton}
						style={styles.iconStyle}
						onClick={props.handleDelete}
						iconClassName="material-icons"
					>
						delete
					</IconButton>
				</Tooltip>
			) : null}
			{props.handleIssue ? (
				<IconButton
					disabled={props.activeButton}
					style={styles.iconStyle}
					onClick={props.handleIssue}
					iconClassName="material-icons"
				>
					receipt
				</IconButton>
			) : null}
			{props.handlePrint ? (
				<Tooltip title="Imprimir boleta" position="top">
					<IconButton
						style={styles.iconStyle}
						onClick={props.handlePrint}
						iconClassName="material-icons"
					>
						print
					</IconButton>
				</Tooltip>
			) : null}
			{props.handleNote ? (
				<Tooltip title={props.showNoty} position="top">
					<IconButton
						disabled={props.activeButton}
						style={styles.iconStyle}
						onClick={props.handleNote}
						iconClassName="material-icons"
					>
						speaker_notes
					</IconButton>
				</Tooltip>
			) : null}
			{props.handleRegenerate ? (
				<Tooltip title={props.showRegenerate} position="top">
					<IconButton
						disabled={props.activeButton}
						style={styles.iconStyle}
						onClick={props.handleRegenerate}
						iconClassName="material-icons"
					>
						receipt
					</IconButton>
				</Tooltip>
			) : null}
			{props.handleEditPayment ? (
				<Tooltip title={props.showEditPayment} position="top">
					<IconButton
						disabled={props.activeButton}
						style={styles.iconStyle}
						onClick={props.handleEditPayment}
						iconClassName="material-icons"
					>
						style
					</IconButton>
				</Tooltip>
			) : null}
		</div>
	);
};
//playlist_add_check
export default OptionsTableRowColumn;



// WEBPACK FOOTER //
// ./src/components/OptionsTableRowColumn/OptionsTableRowColumn.js